import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function AdminNotifications() {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [type, setType] = useState("info");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");

  const token = localStorage.getItem("sk_token");

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const res = await fetch(`${API}/api/admin/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.ok) {
          const data = await res.json();
          setUsers(Array.isArray(data) ? data : data.users || []);
        }
      } catch (err) {
        console.error("Kullanıcılar yüklenemedi:", err);
      }
    };

    loadUsers();
  }, [token]);

  const sendNotification = async (e) => {
    e.preventDefault();

    if (!title.trim() || !message.trim()) {
      setResult("Başlık ve mesaj zorunludur.");
      return;
    }

    setLoading(true);
    setResult("");

    try {
      const res = await fetch(`${API}/api/admin/notifications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title: title.trim(),
          message: message.trim(),
          user_id: userId || null,
          notification_type: type,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.detail || "Bildirim gönderilemedi.");
      }

      setResult(
        userId
          ? "Bildirim kullanıcıya gönderildi."
          : `${data.sent || 0} kullanıcıya bildirim gönderildi.`
      );

      setTitle("");
      setMessage("");
    } catch (err) {
      setResult(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Bildirimler</h1>
        <p className="text-sm text-gray-500 mt-1">
          Üyelere sistem bildirimi gönder.
        </p>
      </div>

      <div className="max-w-3xl bg-white rounded-2xl shadow-sm border p-6">
        <form onSubmit={sendNotification} className="space-y-5">
          <div>
            <label className="block text-sm font-medium mb-2">
              Alıcı
            </label>

            <select
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              className="w-full border rounded-xl px-4 py-3"
            >
              <option value="">Tüm Üyeler</option>

              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.username || user.email || user.id}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">
              Bildirim türü
            </label>

            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="w-full border rounded-xl px-4 py-3"
            >
              <option value="info">Bilgi</option>
              <option value="success">Başarılı</option>
              <option value="warning">Uyarı</option>
              <option value="error">Önemli</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">
              Başlık
            </label>

            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              maxLength={120}
              placeholder="Örn: Sistem Duyurusu"
              className="w-full border rounded-xl px-4 py-3"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">
              Mesaj
            </label>

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              maxLength={2000}
              rows={6}
              placeholder="Üyelere göndermek istediğiniz mesaj..."
              className="w-full border rounded-xl px-4 py-3 resize-none"
            />
          </div>

          {result && (
            <div className="rounded-xl bg-gray-50 border px-4 py-3 text-sm">
              {result}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="px-6 py-3 rounded-xl font-semibold bg-black text-white disabled:opacity-50"
          >
            {loading ? "Gönderiliyor..." : "Bildirim Gönder"}
          </button>
        </form>
      </div>
    </div>
  );
}
